import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Upload, Paperclip, LoaderCircle } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { PutObjectCommand } from "@aws-sdk/client-s3"; 
import { ModalRemoveDocReact } from '../../modals/ModalRemoveDocReact.js';
import { createS3Client } from "../../credentials/awsClients.js";
import HeaderHora from '../../components/headerHora.tsx';
import { CountdownBar } from '../../components/CountdownBar.tsx';
import InternetStatus from '../../components/conexao.tsx';

const s3Client = createS3Client();

export function UploadComprovante() {
    const [uploadedDocs, setUploadedDocs] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const inputRefNaoHabilitado = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        let infoLink = JSON.parse(sessionStorage.getItem('dadosLinkAtual'));
        if(infoLink.outCpr === 'S'){
            navigate('/face');
        }
    }, [navigate]);

    const handleNavigate = useCallback(async () => {
        setIsLoading(true);

        const fileName = `${crypto.randomUUID()}.${uploadedDocs[0].name?.split('.').pop().toLowerCase()}`;

        try {
          const params = {
            Bucket: process.env.REACT_APP_AWS_BUCKET,
            Key: `${JSON.parse(sessionStorage.getItem('dadosLinkAtual')).outDocumento}/docs/${fileName}`,
            Body: uploadedDocs[0],
            ContentType: uploadedDocs[0].type,
          };
    
          const putFile = await s3Client.send(new PutObjectCommand(params));

          if(putFile.$metadata.httpStatusCode === 200){
            
              try{
                const res = await fetch(`${process.env.REACT_APP_URL_API}/conform/send-file`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('sessionTokenBearer')}`,
                        'fileName': `${JSON.parse(sessionStorage.getItem('dadosLinkAtual')).outDocumento}/docs/${fileName}`,
                        'token': sessionStorage.getItem('sessionToken'),
                        'tipo': 'CPR'
                    }
                });
                
                const data = await res.json();
                if(data.erros === false){

                    const raw = sessionStorage.getItem('dadosLinkAtual');
                    const obj = raw ? JSON.parse(raw) : {};
                    obj.outCpr = "S";
                    sessionStorage.setItem('dadosLinkAtual', JSON.stringify(obj));

                    navigate("/face");
                }
              }
              catch (err){
                  console.error("Erro ao enviar arquivo para o S3:", err);
              }
          }
          else{
              console.error("Erro ao enviar arquivo para o S3:");
          }      
        } catch (error) {
          console.error("Erro ao enviar arquivo para o S3:", error);
        }
        finally {
            setIsLoading(false);
        }
    }, [
        uploadedDocs,
        navigate
    ]);

    const handleFileSelect = (event, type) => {
        const files = Array.from(event.target.files);
        const filteredFiles = files.filter(file =>
            [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'image/jpeg',
                'image/png',
                'image/jpg'
            ].includes(file.type)
        );

        if (filteredFiles.length) {
            setUploadedDocs(filteredFiles);
        }
    };

    const handleRemoveFile = () => {
        setUploadedDocs([]);
        setIsOpen(false)
        if (inputRefNaoHabilitado?.current) inputRefNaoHabilitado.current.value = "";
    };

    return (
        <div className='content'>
            <div className='box-document'>
                <HeaderHora/>
                <div className='status-face'>
                    <CountdownBar/>
                    <InternetStatus/>
                </div>
                <div className={`document`}>
                    <div className='l'>
                        <div className='title'>Comprovante de residência</div>
                        <div className='subtitle'>
                            Para prosseguir, envie um comprovante de residência recente (conta de água, luz, internet ou outro documento oficial em seu nome — formatos .pdf, .doc, .docx, .png, .jpg, .jpeg — até 5MB).
                        </div>

                        {uploadedDocs.length > 0 && (
                            <div className='doc-uploaded'>
                                <Paperclip size={14} />
                                <strong>{uploadedDocs[0].name} ({Math.round(uploadedDocs[0].size / 1024 / 1024)}MB)</strong>
                                <span onClick={() => setIsOpen(true)}>[ Excluir ]</span>
                            </div>
                        )}
                    </div>
                    <div className='r' onClick={() => inputRefNaoHabilitado.current.click()}>
                        <Upload size={20} />
                        <input
                            type="file"
                            ref={inputRefNaoHabilitado}
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            style={{ display: 'none' }}
                            onChange={(e) => handleFileSelect(e, 'naoHabilitado')}
                        />
                    </div>
                </div>

                <button onClick={handleNavigate} disabled={uploadedDocs.length === 0}>
                {isLoading
                    ? <LoaderCircle className="spin-loader" size={18} />
                    : 'CONTINUAR'
                }
                </button>

                <ModalRemoveDocReact isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
                    <div className='text-4'>Deseja excluir este arquivo?</div>
                    <div className='text-5'>Ele será apagado permanentemente do sistema.</div>

                    <div className='buttons-group'>
                        <button onClick={() => setIsOpen(false)} className='button-secondary'>CANCELAR</button>
                        <button onClick={handleRemoveFile}>CONFIRMAR</button>
                    </div>
                </ModalRemoveDocReact>

            </div>
        </div>
    );
}
